import {
  GridLegacy as Grid,
  GridLegacyProps as GridProps,
} from '@mui/material';
import React from 'react';

/**
 * @deprecated The component should not be used, use the new Grid from mui https://mui.com/material-ui/react-grid/ instead
 */
export const Col = (props: GridProps) => {
  const { item: _, ...rest } = props;
  return <Grid item {...rest} />;
};
